var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.25H5.625C4.59031 11.25 3.75 10.4112 3.75 9.375V1.875C3.75 0.840306 4.59031 0 5.625 0H13.125C14.1612 0 15 0.840306 15 1.875V9.375C15 10.4112 14.1612 11.25 13.125 11.25ZM14.0617 1.875C14.0617 1.35765 13.6423 0.936735 13.125 0.936735H5.625C5.10765 0.936735 4.68827 1.35612 4.68827 1.875V9.375C4.68827 9.89235 5.10765 10.3133 5.625 10.3133H13.125C13.6423 10.3133 14.0617 9.89388 14.0617 9.375V1.875ZM0.938265 5.625V13.125C0.938265 13.6423 1.35765 14.0617 1.87653 14.0617H9.37653C9.89388 14.0617 10.3148 13.6423 10.3148 13.125V12.1867H11.25V13.125C11.25 14.1597 10.4112 15 9.375 15H1.875C0.838776 15 0 14.1597 0 13.125V5.625C0 4.59031 0.838776 3.75 1.875 3.75H2.81173V4.68674H1.875C1.35765 4.68827 0.938265 5.10765 0.938265 5.625Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c8ca788d0eef5b5a22915029a22e3eff.svg";
export { ForwardRef as ReactComponent };